module.exports = __webpack_public_path__ + "static/img/404.4339481.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/404.png
// module id = JT0z
// module chunks = 2